import React, { useState } from 'react';
import { logIn, getActiveUser } from '../api/api.js';
import Hero from './Hero.js';

const Account = ({user, setUser}) => {
    const [pin, setPin] = useState('');

    const handleSubmit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        await logIn(pin);
        setPin('');
        setUser(await getActiveUser());
    }

    return (
        <div>
            <Hero>
                <section className="section">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-one-third is-offset-one-third">

                                <form onSubmit={handleSubmit}>
                                    <div className="field has-addons">
                                        <p className="control is-expanded">
                                            <input className="input is-primary" type="text" placeholder="PIN" value={pin} onChange={e => setPin(e.target.value)} autoFocus />
                                        </p>
                                        <p className="control">
                                            <input className="button is-dark" type="submit" value="Dalje" />
                                        </p>
                                    </div>

                                    <div className="field has-text-centered">
                                        <strong>Ako nemaš PIN izmisli bilo koji i zapamti ga</strong>
                                        <p className="help is-dark">PIN može biti bilo koje dužine, možeš koristiti i brojeve i slova</p>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </section>
            </Hero>
        </div>
    )
}

export default Account;
